import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import {withStyles} from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Clip from "./Clip";
import qs from "qs";
import Playlist from "./Playlist";
import Collection from "./Collection";
import {Link} from "react-router-dom";
import ErrorBoundary from "../ErrorBoundry";
import axios from "axios";
import urlConfig from "../config";
import OTTService from "../Services/OTTService";
import {connect} from "react-redux";
import {withSnackbar} from "notistack";
import Grid from '@material-ui/core/Grid';
import {givePrivileges,fetchPrivilegesWithRegions,getPrivilegesWithRegions} from '../actions/privilegeActions'
import _ from 'lodash';

import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";

import {SUCCESS} from "../constants";
import CardMedia from "@material-ui/core/CardMedia";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            <Box p={3}>{children}</Box>
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
    },
    tabLink: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    media: {
        width: '200px',
        height: '200px',
        alignContent: 'center'
    },
});


const tabItems = [
    {"label": "Clip Moments", "link": "moments?type=clip", "component": <ErrorBoundary><Clip/></ErrorBoundary>},
    {
        "label": "Moments Playlists",
        "link": "moments?type=playlist",
        "component": <ErrorBoundary><Playlist/></ErrorBoundary>
    },
    {
        "label": "Moments Collections",
        "link": "moments?type=collection",
        "component": <ErrorBoundary><Collection/></ErrorBoundary>
    },

];

class MomentTabs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            authenticationDone:false
        };
    }

    handleChange(event, newValue) {
        this.setState({value: newValue});
    }

    handleChangeIndex(index) {
        this.setState({value: index});
    }

    componentDidMount() {

        let self = this;

        self.props.getPrivilegesWithRegions();
        let parsed = "";
        if ((this.props.location && this.props.location.search)) {
            parsed = qs.parse(this.props.location.search);
        }

        let momentType = "";
        let selectedTabIndex = 0;
        if (parsed["?type"] && parsed["?type"].length > 0) {
            momentType = parsed["?type"];
        }

        if (momentType === "clip") {
            selectedTabIndex = 0;
        } else if (momentType === "playlist") {
            selectedTabIndex = 1;
        } else if (momentType === "collection") {
            selectedTabIndex = 2;
        }

        this.setState({value: selectedTabIndex});
    }

    render() {

        const {classes, theme} = this.props;

        return (
            <div className={classes.root}>

                {this.props.privileges && this.props.privileges.regions && this.props.privileges.regions.length > 0 &&
                <React.Fragment>
                    <Tabs
                        value={this.state.value}
                        onChange={this.handleChange.bind(this)}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        aria-label="Moment Tabs"
                    >

                        {tabItems.map((tabItem, index) => {
                            return <Tab key={index} component={Link} regions={this.props.privileges.regions}
                                        to={tabItem.link} className={classes.tabLink} label={tabItem.label}/>

                        })}
                    </Tabs>

                    <SwipeableViews
                        index={this.state.value}
                        onChangeIndex={this.handleChangeIndex.bind(this)}>

                        {tabItems.map((tabItem, index) => {
                            return <TabPanel value={this.state.value} key={index} index={index} dir={theme.direction}>
                                {tabItem.component}
                            </TabPanel>
                        })}
                    </SwipeableViews>
                </React.Fragment>
                }

                {((!this.state.regions) || (this.state.regions.length === 0)) && (this.state.authenticationDone === true) &&
                <Card>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={8}>
                                <Typography variant={"subtitle1"} align={"center"}>
                                    Since you do not have access to any region on the OTT tool, you can not access this
                                    tool.
                                </Typography>
                            </Grid>
                            <Grid item xs={2}></Grid>
                        </Grid>
                        <br/>
                        <Grid container direction="row"
                              justify="center"
                              alignItems="center" spacing={0}>
                            <Grid item xs={5}></Grid>
                            <Grid item xs={3}>
                                <CardMedia
                                    className={classes.media}
                                    image="pikachu_stop.png"
                                    title="Stop"
                                />
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>


                    </CardContent>
                </Card>

                }
            </div>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        privileges: state.privilege.privileges
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPrivilegesWithRegions: () => dispatch(getPrivilegesWithRegions())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, {withTheme: true})(withSnackbar(MomentTabs)));
